var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.704 5.29L18.707 2.293C18.6143 2.19996 18.5041 2.12617 18.3828 2.07589C18.2614 2.0256 18.1313 1.99981 18 2H6C5.86866 1.99981 5.73857 2.0256 5.61724 2.07589C5.4959 2.12617 5.38571 2.19996 5.293 2.293L2.296 5.29C2.20209 5.38263 2.12755 5.49302 2.07673 5.61475C2.02591 5.73647 1.99983 5.86709 2 5.999V19C2 19.5304 2.21071 20.0391 2.58579 20.4142C2.96086 20.7893 3.46957 21 4 21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V5.999C22.0002 5.86709 21.9741 5.73647 21.9233 5.61475C21.8725 5.49302 21.7979 5.38263 21.704 5.29ZM6.414 4H17.586L18.586 5H5.414L6.414 4ZM17 13V14H7V10H9V12H15V10H17V13Z",
    fill: "#cf0a2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsFull);
export default __webpack_public_path__ + "static/media/documents_full.a534f90c6d0239ac8a875feb63484ff4.svg";
export { ForwardRef as ReactComponent };